import React, { useEffect, useState } from "react";
import Count from "../../components/user/admin/Count";
// import AdminMemberTable from "../../components/user/admin/AdminMemberTable";
import { IMemberListData } from "../../exports/interfaces";
import { fetchMemberLists } from "../../api/MemberApi";
import { dynamicFailed } from "../../hooks/useToast";
import { useLoader } from "../../context/LoaderContext";
import { useUserDataContext } from "../../context/UserDataContext";
import { openLogin } from "../../exports/exports";
import { checkUser } from "../../api/UserApi";

const AdminAffiliateRegistration = () => {
  const { setLoading } = useLoader();
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const [memberCount, setMemberCount] = useState<number>(0);
  const [countryCount, setCountryCount] = useState<number>(0);
  const { userData, setUserData } = useUserDataContext();

  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          userData?.data?.roles[0]?.name !== "sa" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, setUserData, userData]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchMemberLists()])
      .then(([listMemberData]) => {
        setListMemberData(listMemberData);
        const activeMembers = listMemberData.filter(
          (member: IMemberListData) => member.attributes?.Status === "Active"
        );

        setMemberCount(activeMembers.length);

        const countries = activeMembers.map((member: IMemberListData) =>
          member.attributes?.Country?.trim()
        );
        const uniqueCountries = new Set(countries.filter(Boolean));
        setCountryCount(uniqueCountries.size);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [listMemberData.length, setLoading]);
  return (
    <>
      <Count
        Title={"Affiliate Member Registration"}
        memberCount={memberCount}
        countryCount={countryCount}
      />
      {/* <AdminMemberTable listMemberData={listMemberData} /> */}
    </>
  );
};

export default AdminAffiliateRegistration;
